module.exports = __webpack_public_path__ + "img/40-1-n.32e416b7.png";